export default __webpack_public_path__ + "static/media/bizcovery_pvt_ltd_challan_fy_23-24.df25afd6.pdf";